import { render, staticRenderFns } from "./CompLoading.vue?vue&type=template&id=c15cc5f2&"
import script from "./CompLoading.vue?vue&type=script&lang=js&"
export * from "./CompLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports